import styled from 'styled-components';
import { Typography } from '../../../../stories/atoms';
import { Colors } from '../../../../theme';

export const StyledTypography = styled(Typography)`
  color: ${({ theme: { color, palette } }) => palette.mode === 'dark' && color.white};
`;

export const TrendTypography = styled(Typography)<{ trendColor: Colors }>`
  color: ${({ theme: { color }, trendColor }) => color[trendColor]};
`;
